import * as React from 'react';
import cn from 'classnames';

import styles from './AvailabilityCalendar.module.scss';
import calendarStyles from './Calendar.module.scss';
import Calendar from './Calendar';
import { VenueProfileContext } from '../../context';

const AvailabilityCalendar = () => {
    const { wsVenueProfile } = React.useContext(VenueProfileContext);
    if (!wsVenueProfile) {
        return <></>;
    }
    const availability = React.useMemo<{ [date: string]: number } | null>(() => {
        if ('availability' in wsVenueProfile && wsVenueProfile.availability) {
            return wsVenueProfile.availability.reduce((prev, [date, _, status]) => {
                prev[date] = status;
                return prev;
            }, {});
        }
        return null;
    }, [wsVenueProfile]);

    // Set class name to highlight special days on calendars
    const getDateClassname = React.useCallback(
        (day, month, year) => {
            if (availability === null) {
                return '';
            }

            // Make days that no in this month invisible
            if (day === 0) {
                return calendarStyles.dateTransparent;
            }

            const today = new Date().setHours(0, 0, 0, 0);
            // Make days before today grey
            if (new Date(year, month, day).setHours(0, 0, 0, 0) < today) {
                return calendarStyles.dateGrey;
            }

            // Get date in format month/day/year to highlight availability
            const date = (month + 1 < 10 ? '0' + (month + 1) : month + 1) + '/' + (day < 10 ? '0' + day : day) + '/' + year;

            const status = availability[date];

            // Highlight today date
            if (new Date(year, month, day).setHours(0, 0, 0, 0) === today && !status) {
                return calendarStyles.dateToday;
            }

            switch (status) {
                case 0:
                    return '';
                case 1:
                    return calendarStyles.dateBlack;
                case 2:
                    return calendarStyles.datePink;
                case 4:
                    return calendarStyles.dateBlue;
                default:
                    return '';
            }
        },
        [availability]
    );

    return (
        <div className={styles.availability}>
            <h2>Availability</h2>
            <div className={styles.key}>
                <span className={styles.keyItem}>
                    <div className={cn(styles.keyBox, styles.pink)} />
                    <span className={styles.keyLabel}>Partially Reserved</span>
                </span>
                <span className={styles.keyItem}>
                    <div className={cn(styles.keyBox, styles.blue)} />
                    <span className={styles.keyLabel}>Daytime Only Available</span>
                </span>
                <span className={styles.keyItem}>
                    <div className={cn(styles.keyBox, styles.black)} />
                    <span className={styles.keyLabel}>Reserved</span>
                </span>
            </div>
            <Calendar minDate={[]} getDateClassname={getDateClassname} />
        </div>
    );
};

export default AvailabilityCalendar;
